export default __webpack_public_path__ + "static/section3_feature2-5f6886e0d4236dd91848ab73ff9d554a.png";